/*
 * @Author: shenjue 303729397@qq.com
 * @Date: 2022-01-20 13:49:54
 * @LastEditors: shenjue 303729397@qq.com
 * @LastEditTime: 2025-05-29 17:23:04
 * @FilePath: \hyc-admin\src\api\energyMG.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from 'axios';
import { req,reqObj,reqObjGet} from './axiosFun';
import { downLoadReq,downLoadPostReq }  from "./downLoad"
// -------------------------------------抄表数据  2025-05-29 编辑ES-----------------------------------
// 电 
export const handlerPowerData = (params) => { return reqObj("/api/esMeterData/handlerPowerData",params)};
// 水
export const handlerWaterData = (params) => { return reqObj("/api/esMeterData/handlerWaterData",params)};
// 天然气
export const handlerGasData = (params) => { return reqObj("/api/esMeterData/handlerGasData",params)};
// 流量计
export const handlerSteamData = (params) => { return reqObj("/api/esMeterData/handlerSteamData",params)};
export const getMeterReadingDataPoiFiterNew = (params) => { return downLoadPostReq("/api/meterData/getMeterReadingDataPoiFiterNew", params) };
//获取抄表数据列表
export const getMeterReadingDataES = (params) => { return reqObj("/api/meterData/getMeterReadingData", params) };

// 2024-1-30 采集数据失败记录统计 导出
export const poiDataCollectFailDepartment = (params) => { return downLoadReq("get","api/dataCollectionFailCount/poiDataCollectFailDepartment", params) };

// ------------------------------2023-1-29 用能结构-刷新-------------------
// 刷新  
// export const queryMeterStatus = (params) => { return req("post", "/api/power/queryMeterStatus", params) };


//获取计量点信息列表
export const findMeterInfoListES = (params) => { return reqObjGet("/api/meterInfo/findMeterInfoList", params) };

//获取计量点信息列表
export const findMeterInfoList = (params) => { return req("get", "/api/meterInfo/findMeterInfoList", params) };

export const findMeterInfoListOpenAccount = (params) => { return req("get", "/api/meterInfo/findMeterInfoListOpenAccount", params) };



//获取部门与集中器列表
export const getDepartmentTerminalInfoLis = (params) => { return req("get", "/api/terminalInfo/getDepartmentTerminalInfoList", params) };

//通过部门id获取集中器id列表
export const getTerminalInfoByDepId = (params) => { return req("get", "/api/terminalInfo/getTerminalInfoByDepId", params) };

//删除计量点
export const deleteMeterInfo = (params) => { return req("post", "/api/meterInfo/deleteMeterInfo", params) };

//集中器信息列表
export const getTerminalInfoList = (params) => { return req("get", "/api/terminalInfo/getTerminalInfoList", params) };

//通过类型获取所有相关配置选项
export const getAllConfigurationList = (params) => { return req("get", "/api/terminalInfo/getAllConfigurationList", params) };

//添加集中器信息
export const terminalInfoAdd = (params) => { return req("post", "/api/terminalInfo/terminalInfoAdd", params) };

//修改集中器信息
export const terminalInfoUpdate = (params) => { return req("post", "/api/terminalInfo/terminalInfoUpdate", params) };

//删除集中器信息
export const terminalInfoDelete = (params) => { return req("post", "/api/terminalInfo/terminalInfoDelete", params) };

//获取所有采集数据项
export const getAllDataItemList = (params) => { return req("get", "/api/meterInfo/getAllDataItemList", params) };

//添加计量点时获取集中器列表
export const getTerminalInfoListByAddMeterInfo = (params) => { return req("get", "/api/terminalInfo/getTerminalInfoListByAddMeterInfo", params) };

//添加计量点
export const addMeterInfo = (params) => { return req("post", "/api/meterInfo/addMeterInfo", params) };

//修改计量点
export const updateMeterInfo = (params) => { return req("post", "/api/meterInfo/updateMeterInfo", params) };

//获取抄表数据列表
export const getMeterReadingData = (params) => { return req("get", "/api/meterData/getMeterReadingData", params) };

//获取用能数据列表
export const getMeterEnergyData = (params) => { return req("post", "/api/meterData/getMeterEnergyData", params) };

//导入计量点
export const uploadjl = (params) => { return req("post", "/api/meterInfo/uploadMeterInfoList", params,true) };

//导入集中器列表
export const uploadTerm = (params) => { return req("post", "/api/terminalInfo/uploadTerminalInfoList", params,true) };

//通过省市获取所有房间
export const getRoomList = (params) => { return req("get", "/api/room/getRoomAllListByProAndCity", params) };


//导出实时数据列表
export const getRealTimeDataPoiFiter = (params) => { return downLoadReq("get","/api/meterData/getRealTimeDataPoiFiter", params) };

//导出抄表数据列表
export const getMeterReadingDataPoiFiter = (params) => { return downLoadReq("get","/api/meterData/getMeterReadingDataPoiFiter", params) };

//导出用能数据列表
export const getMeterEnergyDataPoiFiter = (params) => { return downLoadReq("post","/api/meterData/getMeterEnergyDataPoiFiter", params) };

//查询拉合闸状态
export const getMeterInfoStatus = (params) => { return req("post", "/api/meterInfo/getMeterInfoStatus", params) };

//导出账单
export const poiAccountList = (params) => { return downLoadReq("get","/api/account/poiAccountList", params) };

//交易记录导出
export const poiAccountDetailList = (params) => { return downLoadReq("get","/api/account/poiAccountDetailList", params) };

export const poiAccountHistoryList = (params) => { return downLoadReq("get","/api/account/poiAccountHistoryList", params) };


//充值管理导出
export const findAppletUserMoneyPoiFiter = (params) => { return downLoadReq("get","/api/meterInfo/findAppletUserMoneyPoiFiter", params) };


//获取能源分项信息
export const getEnergyTypeList = (params) => { return req("get","/api/energy/findEnergyDataList", params) };

//获取当前表数据
export const getDetailRealData = (params) => { return req("get","/api/meterData/getMeterReadingDataByMeterInfoId", params) };


export const getEnegySubItem = (params) => { return req("get","/api/index/findDepartmentEnergyData", params) };


export const getDinList = (params) => { return req("get","/api/dataCall/getDinList", params) };


//召读数据获取计量点信息
export const findMeterListByCall = (params) => { return req("get","/api/meterInfo/findMeterListByCall", params) };

//实时数据召读
export const newDataCall = (params) => { return req("post","/api/dataCall/newDataCall", params) };

//历史数据召读
export const freezeDataCall = (params) => { return req("post","/api/dataCall/freezeDataCall", params) };

//获取采集方案
export const getAllDcsCollectschemeList = (params) => { return req("get","/api/dscCollect/getAllDcsCollectschemeList", params) };

//添加采集方案
export const addDcsCollectscheme = (params) => { return req("post","/api/dscCollect/addDcsCollectscheme", params) };

//删除采集方案
export const delDcsCollectscheme = (params) => { return req("post","/api/dscCollect/delDcsCollectscheme", params) };

//获取采集详情
export const getSchemeDetail = (params) => { return req("get","/api/dscCollect/getAllDcsCollectschemedetailListBySchemeid", params) };

//获取数据项
export const getDataItems = (params) => { return req("get","/api/dscCollect/getAllDcsProtocoldatatypeListByProtocolId", params) };

//添加采集方案详情
export const addDcsCollectschemedetail = (params) => { return req("post","/api/dscCollect/addDcsCollectschemedetail", params) };

//删除采集方案详情
export const delDcsCollectschemedetail = (params) => { return req("post","/api/dscCollect/delDcsCollectschemedetail", params) };

//远程拉合闸
export const getSwitch = (params) => { return req("post","/api/windowsData/getSwitch", params) };

//远程拉合闸新
export const getSwitchNew = (params) => { return req("post","/api/windowsData/getSwitchNew", params) };


//拉合闸校验
export const CheckSwitchAdmin = (params) => { return req("post","/api/windowsData/CheckSwitchAdmin", params) };

//参数下发
export const meterParamSend = (params) => { return req("post","/api/dataCall/meterParamSend", params) };

//防窃电
export const sendRelayFrame = (params) => { return req("post","/api/dataCall/sendRelayFrame", params) };


export const sendRelayFrameCall = (params) => { return req("post","/api/dataCall/sendRelayFrameCall", params) };

export const getElePreventionTaskList = (params) => { return req("get","/api/dataCall/getElePreventionTaskList", params) };

export const getElePreventionTaskFile = (params) => { return downLoadReq("get","/api/dataCall/getElePreventionTaskFile", params) };

export const reset = (params) => { return req("post","/api/rtuResetTimeSync/reset", params) };

export const sendRelayFrameCallNew = (params) => { return req("post","/api/dataCall/sendRelayFrameCallNew", params) };

export const getMeterInfoParam = (params) => { return req("post","/api/dataCall/getMeterInfoParam", params) };

export const findTask = (params) => { return req("get","/api/eeleTask/findTask", params) };

export const findEnergyFreezeList = (params) => { return req("get","/api/eeleTask/findEnergyFreezeList", params) };

export const findTaskDownList = (params) => { return req("get","/api/eeleTask/findTaskDownList", params) };

export const findAbroachList = (params) => { return req("get","/api/eeleTask/findAbroachList", params) };

export const findEEleHardPowerDataList = (params) => { return req("get","/api/eeleTask/findEEleHardPowerDataList", params) };

export const sendRelayFrameCallTask = (params) => { return req("post","/api/dataCall/sendRelayFrameCallTask", params) };

export const findFreezeDateList = (params) => { return req("get","/api/eeleTask/findFreezeDateList", params) };

export const findTradeReceiptByAccountId = (params) => { return req("get","/api/tradeReceipt/findTradeReceiptByAccountId", params) };

export const findVoucherByAccountId = (params) => { return req("get","/api/voucher/findVoucherByAccountId", params) };

export const updateMeterInfoToMain = (params) => { return req("post","/api/lineWastage/updateMeterInfoToMain", params) };



export const getIsHaveMainMeterInfoDataByCode = (params) => { return req("post","/api/lineWastage/getIsHaveMainMeterInfoDataByCode", params) };

export const getMeterInfoDataByParentId = (params) => { return req("post","/api/lineWastage/getMeterInfoDataByParentId", params) };

export const updateMeterInfoMainAndSonRelation = (params) => { return req("post","/api/lineWastage/updateMeterInfoMainAndSonRelation", params) };

export const removeMeterInfoToRelation = (params) => { return req("post","/api/lineWastage/removeMeterInfoToRelation", params) };

export const saveOrUpdateArea = (params) => { return req("post","/api/area/saveOrUpdateArea", params) };

export const findAreaList = (params) => { return req("get","/api/area/findAreaList", params) };

export const AreaDelete = (params) => { return req("post","/api/area/AreaDelete", params) };

export const getMeterInfoList = (params) => { return req("get","/api/area/findMeterInfoList", params) };

export const addAreaMeterInfo = (params) => { return req("post","/api/area/addAreaMeterInfo", params) };

export const removeAreaMeterInfo = (params) => { return req("post","/api/area/removeAreaMeterInfo", params) };

export const findParentSonMeterList = (params) => { return req("get","/api/lineWastage/findParentSonMeterList", params) };

export const getMainMeterInfoDataByCode = (params) => { return req("get","/api/lineWastage/getMainMeterInfoDataByCode", params) };

export const getDepartmentIdByMeterInfos = (params) => { return req("get","/api/meterInfo/getDepartmentIdByMeterInfos", params) }; //根据部门获取计量点


export const findMeterInfoPoiFiter = (params) => { return downLoadReq("get","/api/meterInfo/findMeterInfoPoiFiter", params) };



export const getMeterPointParamPoi = (params) => { return downLoadReq("get", "/api/dataCall/getMeterPointParamPoi", params) };


export const getOneMeterOverview = (params) => { return req("get", "/api/meterData/getOneMeterOverview", params) };

export const getOneMeterReadingData = (params) => { return req("get", "/api/meterData/getOneMeterReadingData", params) };

export const getMeterInfoByTerCodeAndPointCode = (params) => { return req("get", "/api/meterInfo/getMeterInfoByTerCodeAndPointCode", params) };



export const findItemListByName = (params) => { return req("get", "/api/dataCall/findItemListByName", params) };

export const ifGWOrNW = (params) => { return req("get", "/api/dataCall/ifGWOrNW", params) };

export const newGWDataCall = (params) => { return reqObj("/api/dataCall/newGWDataCall", params) };

export const freezeGWDataCall = (params) => { return reqObj("/api/dataCall/freezeGWDataCall", params) };

export const getMeterPointParam = (params) => { return reqObj("/api/dataCall/getMeterPointParam", params) };

export const getMeterGWPointParam = (params) => { return reqObj("/api/dataCall/getMeterGWPointParam", params) };

export const addGWRuleConfig = (params) => { return reqObj("/api/dataCall/addGWRuleConfig", params) };

export const findAllGWRuleConfig = (params) => { return req('get', "/api/dataCall/findAllGWRuleConfig", params) };

export const deleteGWRuleConfig = (params) => { return reqObj("/api/dataCall/deleteGWRuleConfig", params) };

export const updateGWRuleConfig = (params) => { return reqObj("/api/dataCall/updateGWRuleConfig", params) };

export const findPointAddrByGWConfig = (params) => { return reqObj("/api/dataCall/findPointAddrByGWConfig", params) };

export const generateMonthBill = (params) => { return req("post","/api/monthlyBill/generateMonthBill", params) };

export const selectMonthBillData = (params) => { return req("get","/api/monthlyBill/selectMonthBillData", params) };



export const generateFinalMonthBill = (params) => { return req("post","/api/monthlyBill/generateFinalMonthBill", params) };

export const selectFinalMonthBillData = (params) => { return req("get","/api/monthlyBill/selectFinalMonthBillData", params) };


export const pushDataToEIP = (params) => { return req("post","/api/monthlyBill/pushDataToEIP", params) };

export const exportMonthBillData = (params) => { return downLoadReq("get","/api/monthlyBill/exportMonthBillData", params) };


//账单数据导出
export const getBillDataPoiFiter = (params) => { return downLoadReq("get","/api/monthlyBill/exportMonthBillData", params) };

export const generateBillDataAdvance = (params) => { return req("post","/api/newMonthBillData/generateBillDataAdvance", params) };

//生成预存通知单
export const generateNotice = (params) => { return req("post","/api/newMonthBillData/generateNotice", params) };


export const getDayAvgDegree = (params) => { return req("get","/api/meterInfo/getDayAvgDegree", params) };


export const getAllUnitPriceConfig = (params) => { return req("post","/api/priceConfig/getAllUnitPriceConfig", params) };

export const getPower = (params) => { return reqObj("/api/meterInfo/getPower", params) };


export const queryMeterStatus = (params) => { return req('post',"/api/power/queryMeterStatus", params) };

// export const enerateBillDataAdvance = (params) => { return req("post","/api/newMonthBillData/generateBillDataAdvance", params) };



// WEBPACK FOOTER //
// ./src/api/energyMG.js